import React from 'react';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';

const Dashboard = () => {
  const { user } = useAuth();

  const modules = [
    { nombre: 'Logística', desc: 'Requerimientos, órdenes de compra, comparativas', icon: '📦', path: '/logistica' },
    { nombre: 'Almacén', desc: 'Compras, ventas, ingresos, salidas, producción', icon: '🏭', path: '/almacen' },
    { nombre: 'Kardex', desc: 'Movimiento de inventarios', icon: '📋', path: '/kardex' },
    { nombre: 'Cobranzas', desc: 'Control de cuentas por cobrar', icon: '💰', path: '/cobranzas' },
    { nombre: 'Pagos', desc: 'Control de cuentas por pagar', icon: '💳', path: '/pagos' },
  ];

  return (
    <Layout title="Dashboard" subtitle={`Bienvenido, ${user?.nombre || 'Usuario'}`}>
      <h2 style={{ fontSize: '20px', fontWeight: 600, marginBottom: '24px' }}>
        Módulos del Sistema
      </h2>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: '16px'
      }}>
        {modules.map((mod) => (
          <div
            key={mod.nombre}
            style={{
              background: 'rgba(255,255,255,0.04)',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: '16px',
              padding: '24px 20px',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(59,130,246,0.08)';
              e.currentTarget.style.borderColor = 'rgba(59,130,246,0.25)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255,255,255,0.04)';
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <div style={{ fontSize: '28px', marginBottom: '10px' }}>{mod.icon}</div>
            <h3 style={{ fontSize: '15px', fontWeight: 600, marginBottom: '6px' }}>{mod.nombre}</h3>
            <p style={{ fontSize: '12.5px', color: 'rgba(148,163,184,0.7)' }}>{mod.desc}</p>
          </div>
        ))}
      </div>
    </Layout>
  );
};

export default Dashboard;
